/* prettsun-blog-toc.js — 文章页增强（只作用于文章页的 .blog-post-content）
   ── ① 文内目录 TOC ────────────────────────────────────────────────
      · 只读取正文里「已经存在」的 h2/h3 id，绝不自己造 id（id 由正文侧负责）
      · 仅当 h2(id) 数量 ≥ 3 时才渲染（短文不加目录）
      · h3 归到其上方最近的 h2 下（嵌套 <ol class="ps-toc__sublist">）
      · 插在「第一个 <p>/<blockquote> 之后、第一个 <h2> 之前」这个区间内，
        实际落在第一个 <h2> 之前，保证目录在所有小节之上
      · 点击 → 平滑滚动（尊重 prefers-reduced-motion），并把焦点交给目标标题
      · 移动端（≤749px）折叠：原生 button + aria-expanded，无重依赖
      · 无障碍：<nav aria-labelledby>，键盘可达
   ── ② 外链新窗口规则 ─────────────────────────────────────────────
      · 站外 http(s) 链接 → target="_blank" + rel="noopener" + "opens in a new window" 提示
      · 站内相对链接（/pages、/products、/blogs …）一律不动
      · youtube 时间戳链接（?t=..）由 prettsun-blog-video.js 接管，显式排除
   幂等：重复执行不会重复注入 / 不会重复改属性。
   ── 2026-09-26 ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var content = document.querySelector('.blog-post-content');
  if (!content) return; // 非文章页 → 什么都不做

  /* ================= ① 文内目录 TOC ================= */
  function buildToc() {
    if (content.querySelector('.ps-toc')) return;                 // 幂等
    var heads = content.querySelectorAll('h2[id], h3[id]');
    if (!heads.length) return;                                    // 正文还没有 id → 不渲染
    if (content.querySelectorAll('h2[id]').length < 3) return;    // h2 < 3 的短文不加目录

    // 组装层级树：h3 挂到上方最近的 h2；出现在任何 h2 之前的 h3 放顶层
    var tree = [];
    for (var i = 0; i < heads.length; i++) {
      var el = heads[i];
      var node = {
        id: el.id,
        text: (el.textContent || '').replace(/\s+/g, ' ').trim(),
        children: []
      };
      if (el.tagName === 'H3' && tree.length) tree[tree.length - 1].children.push(node);
      else tree.push(node);
    }
    if (!tree.length) return;

    function makeList(cls, items) {
      var list = document.createElement('ol');
      list.className = cls;
      for (var k = 0; k < items.length; k++) {
        var li = document.createElement('li');
        li.className = 'ps-toc__item';
        var a = document.createElement('a');
        a.setAttribute('href', '#' + items[k].id);
        a.textContent = items[k].text || items[k].id;
        li.appendChild(a);
        if (items[k].children.length) {
          li.appendChild(makeList('ps-toc__sublist', items[k].children));
        }
        list.appendChild(li);
      }
      return list;
    }

    var nav = document.createElement('nav');
    nav.className = 'ps-toc';
    nav.setAttribute('aria-labelledby', 'ps-toc-title');

    var title = document.createElement('p');
    title.className = 'ps-toc__title';
    title.id = 'ps-toc-title';
    title.textContent = 'On this page';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ps-toc__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', 'ps-toc-list');
    toggle.innerHTML = '<span class="ps-toc__toggle-label">On this page</span>' +
                       '<span class="ps-toc__chevron" aria-hidden="true"></span>';

    var root = makeList('ps-toc__list', tree);
    root.id = 'ps-toc-list';

    nav.appendChild(title);
    nav.appendChild(toggle);
    nav.appendChild(root);

    // 插入点：第一个 <h2>/<h3> 之前；找不到标题则退化为正文第一个 <p>/<blockquote> 之后
    var scope = content.querySelector('rte-formatter') || content;
    var kids = scope.children;
    var firstHeading = null;
    var firstBlock = null;
    for (var j = 0; j < kids.length; j++) {
      var tag = kids[j].tagName;
      if (tag === 'H2' || tag === 'H3') { firstHeading = kids[j]; break; }
      if (!firstBlock && (tag === 'P' || tag === 'BLOCKQUOTE')) firstBlock = kids[j];
    }
    if (firstHeading) {
      firstHeading.parentNode.insertBefore(nav, firstHeading);
    } else if (firstBlock) {
      firstBlock.parentNode.insertBefore(nav, firstBlock.nextSibling);
    } else {
      scope.insertBefore(nav, scope.firstChild);
    }

    // 移动端折叠开关
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('ps-toc--open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // 点击目录项 → 平滑滚动 + 焦点转移
    root.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var reduce = false;
      try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) {}
      try { target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      catch (err) { target.scrollIntoView(); }
      if (window.history && history.replaceState) history.replaceState(null, '', '#' + id);
      nav.classList.remove('ps-toc--open');
      toggle.setAttribute('aria-expanded', 'false');
      target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
    });
  }

  /* ================= ② 外链新窗口规则 ================= */
  function externalLinks() {
    var links = content.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.dataset.psExternal === '1') continue;                       // 幂等
      var href = a.getAttribute('href') || '';
      // youtube 时间戳链接由 prettsun-blog-video.js 接管（页内滚动），显式排除
      if (href.indexOf('youtube.com/watch') !== -1 && /[?&]t=\d/.test(href)) continue;

      var url;
      try { url = new URL(href, window.location.href); } catch (err) { continue; }
      if (url.protocol !== 'http:' && url.protocol !== 'https:') continue;   // mailto:/tel:/# 不动
      if (url.hostname.replace(/^www\./i, '').toLowerCase() === 'prettsun.com') continue; // 站内不动

      a.setAttribute('target', '_blank');
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      a.setAttribute('rel', rel.join(' '));
      if (!a.getAttribute('title')) a.setAttribute('title', 'Opens in a new window');
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (label && !/opens in a new window/i.test(a.getAttribute('aria-label') || '')) {
        a.setAttribute('aria-label', label + ', opens in a new window');
      }
      a.dataset.psExternal = '1';
    }
  }

  function run() { buildToc(); externalLinks(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
